/*jshint esversion: 6 */

export { default as LoadingSpinner } from '../../core/components/LoadingSpinner.vue';

export { default as StepBar } from './Sections/StepBar.vue';
export { default as StepLink } from './Sections/StepLink.vue';
export { default as SelectDateTime } from './Sections/SelectDateTime.vue';
export { default as SelectDate } from './Sections/SelectDate.vue';
export { default as VehicleDetails } from './Sections/VehicleDetails.vue';
export { default as ManualValuationForm} from './Sections/ManualValuationForm.vue';
export { default as ValuationAmount} from './Sections/ValuationAmount.vue';
export { default as QrCode} from './Sections/QrCode.vue';
export { default as CreateAccount} from './Sections/CreateAccount.vue';
export { default as CreateAccountModal} from "./Sections/CreateAccountModal.vue";
export { default as RadioOptionButtons} from "./Sections/RadioOptionButtons.vue";
export { default as VehicleImage} from "./Sections/VehicleImage.vue";

export { default as FindMyCar } from './Steps/FindMyCar.vue';
export { default as ConfirmYourCar } from './Steps/ConfirmYourCar.vue';
export { default as YourSummary } from './Steps/YourSummary.vue';
export { default as YourValuation} from './Steps/YourValuation.vue';
export { default as ManualValuationConfirmation} from './Steps/ManualValuationConfirmation.vue';

export { default as VehicleCondition} from './ExactValuationSteps/VehicleCondition.vue';
export { default as ServiceHistory} from './ExactValuationSteps/ServiceHistory.vue';
export { default as MechanicalCondition} from './ExactValuationSteps/MechanicalCondition.vue';
export { default as VehicleWalkaround} from './ExactValuationSteps/VehicleWalkaround.vue';



// WEBPACK FOOTER //
// ./resources/assets/js/valuation-tool/components/index.js